// shrine-patch.js - Parche de seguridad
(function() {
  'use strict';
  
  // Bloquear llamadas al servidor de licencias
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    // Bloquear URLs de verificación
    if (typeof url === 'string' && 
        (url.includes('shrinetheme.com') || 
         url.includes('whatsmycountry.com'))) {
      console.log('Verificación externa bloqueada:', url);
      return Promise.resolve({
        ok: true,
        status: 200,
        json: () => Promise.resolve({ verified: true }),
        text: () => Promise.resolve('')
      });
    }
    return originalFetch.apply(this, arguments);
  };
  
  // Forzar serial válido
  window.serial = 'VALID_LICENSE';
  
  // Override de función de bloqueo
  if (window.metafieldPoly) {
    window.metafieldPoly = function() {
      if (window.playMedia) window.playMedia();
      return true;
    };
  }
  
  // Prevenir inyección de HTML no autorizado
  const originalInnerHTMLSetter = Object.getOwnPropertyDescriptor(
    Element.prototype, 
    'innerHTML'
  ).set;
  
  Object.defineProperty(Element.prototype, 'innerHTML', {
    set: function(value) {
      // Permitir cambios normales del tema
      if (typeof value === 'string' && 
          !value.includes('license') && 
          !value.includes('blocked')) {
        originalInnerHTMLSetter.call(this, value);
      } else {
        console.warn('Inyección HTML sospechosa bloqueada');
      }
    }
  });
  
  console.log('✅ Parche de seguridad activado');
})();